import { useEffect } from 'react';
import { useUser } from '../user/userStore';
import { currencyActions } from './currencyStore';

/**
 * Component to initialize the currency store.
 * Fetches currencies when user is logged in.
 * Should be mounted once at the app level.
 */
export const CurrencyStoreInitializer = () => {
    const user = useUser();

    useEffect(() => {
        if (user.loaded && user.token) {
            currencyActions.fetchCurrencies();
        }
    }, [user.loaded, user.token]);

    return null;
};
